/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerCartItemDto } from './BorrowerCartItemDto';
import {
    BorrowerCartItemDtoFromJSON,
    BorrowerCartItemDtoFromJSONTyped,
    BorrowerCartItemDtoToJSON,
    BorrowerCartItemDtoToJSONTyped,
} from './BorrowerCartItemDto';
import type { NotificationResponse } from './NotificationResponse';
import {
    NotificationResponseFromJSON,
    NotificationResponseFromJSONTyped,
    NotificationResponseToJSON,
    NotificationResponseToJSONTyped,
} from './NotificationResponse';

/**
 * 
 * @export
 * @interface GetBorrowerShoppingCartResponse
 */
export interface GetBorrowerShoppingCartResponse {
    /**
     * 
     * @type {Array<BorrowerCartItemDto>}
     * @memberof GetBorrowerShoppingCartResponse
     */
    items: Array<BorrowerCartItemDto>;
    /**
     * 
     * @type {NotificationResponse}
     * @memberof GetBorrowerShoppingCartResponse
     */
    notification?: NotificationResponse;
}

/**
 * Check if a given object implements the GetBorrowerShoppingCartResponse interface.
 */
export function instanceOfGetBorrowerShoppingCartResponse(value: object): value is GetBorrowerShoppingCartResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetBorrowerShoppingCartResponseFromJSON(json: any): GetBorrowerShoppingCartResponse {
    return GetBorrowerShoppingCartResponseFromJSONTyped(json, false);
}

export function GetBorrowerShoppingCartResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBorrowerShoppingCartResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(BorrowerCartItemDtoFromJSON)),
        'notification': json['notification'] == null ? undefined : NotificationResponseFromJSON(json['notification']),
    };
}

export function GetBorrowerShoppingCartResponseToJSON(json: any): GetBorrowerShoppingCartResponse {
    return GetBorrowerShoppingCartResponseToJSONTyped(json, false);
}

export function GetBorrowerShoppingCartResponseToJSONTyped(value?: GetBorrowerShoppingCartResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(BorrowerCartItemDtoToJSON)),
        'notification': NotificationResponseToJSON(value['notification']),
    };
}

